import store from 'store';

const base = (website) => {
  return ({
    tagline: `Welcome to ${website.root.companyName}`,
    taglineDescription: website.root.tagline,
  });
};

const butterfly = (website) => {
  return({
    ...base(website),
    heading: website.root.heading,
  })
};

const knight = (website) => {
  return({
    ...base(website),
    logoURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/businesses%2FMWBOg2WQpmhNKkufUAarVr6C3043%2Flogo%2Fpincrestlogo.png?alt=media&token=a5926712-ce13-4ada-b845-1f9376db8d61",
  })
};

const vlava = (website) => {
  const { heroImagesState } = store.getState();
  const { heroImage = "hero1.jpg" } = website.root;
  const heroImageURL = heroImagesState.find(i => i.filename === heroImage);
  return({
    ...base(website),
    bgImage: heroImageURL.downloadURL,
    logoURL: "https://firebasestorage.googleapis.com/v0/b/couraggo.appspot.com/o/businesses%2FMWBOg2WQpmhNKkufUAarVr6C3043%2Flogo%2FPinecrestFINAL-%20Trans%20-%20White.png?alt=media&token=fed96f06-2015-456c-bf2c-5c749b8ff26f",
  });
}

export const RootFactory = {
  getBase: base,
  getButterfly: butterfly,
  getKnight: knight,
  getVlava: vlava,
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/factories/RootFactory.js